export default __webpack_public_path__ + "static/media/victory.70f7209d.png";